import { useState, useEffect, useRef } from 'react'
import { ReactComponent as IconCalendar } from 'bootstrap-icons/icons/calendar3.svg'
import { toISODate, toDisplayDate, maskDateDigits } from './date'
import styles from './styles.module.scss'

/** Input de fecha forzado a dd/mm/yyyy + picker nativo; onChange entrega YYYY-MM-DD o null. */
function DateInput({ value, onChange, className, style, disabled }) {
  const [text, setText] = useState(() => toDisplayDate(value))
  const pickerRef = useRef(null)

  useEffect(() => {
    setText(toDisplayDate(value))
  }, [value])

  const commit = (raw) => {
    const iso = toISODate(raw)
    if (!raw || !String(raw).trim()) {
      setText('')
      onChange(null)
      return
    }
    if (iso) {
      setText(toDisplayDate(iso))
      onChange(iso)
    } else {
      setText(maskDateDigits(raw))
    }
  }

  const onType = (e) => {
    const next = maskDateDigits(e.target.value)
    setText(next)
    if (next.replace(/\D/g, '').length === 8) {
      const iso = toISODate(next)
      if (iso) onChange(iso)
    }
  }

  const openPicker = () => {
    const el = pickerRef.current
    if (!el) return
    if (typeof el.showPicker === 'function') {
      try { el.showPicker() } catch (_) { el.click() }
    } else {
      el.click()
    }
  }

  const isoValue = toISODate(value) || ''

  return (
    <div className={styles.dateInputWrap} style={style}>
      <input
        type="text"
        inputMode="numeric"
        placeholder="dd/mm/yyyy"
        className={className || 'form-control'}
        value={text}
        disabled={disabled}
        onChange={onType}
        onBlur={(e) => commit(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); commit(e.target.value) } }}
        aria-label="Fecha dd/mm/yyyy"
      />
      <button type="button" className={styles.datePickerBtn} onClick={openPicker} disabled={disabled} title="Abrir calendario" aria-label="Abrir calendario">
        <IconCalendar width="15" height="15" />
      </button>
      <input
        ref={pickerRef}
        type="date"
        className={styles.datePickerNative}
        value={isoValue}
        disabled={disabled}
        onChange={(e) => {
          const iso = e.target.value || null
          setText(iso ? toDisplayDate(iso) : '')
          onChange(iso)
        }}
        tabIndex={-1}
        aria-hidden="true"
      />
    </div>
  )
}

export default DateInput
